module.exports = __webpack_public_path__ + "img/71400.dc713428.jpg";